const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Build-time rendering and the first browser render must use the same data.
// Keep the server cache separate from browser globals; effects can still refresh
// content from the API after hydration without replacing the initial layout.
let initialContent;
export const setInitialContent = content => { initialContent = content; };
export const getInitialContent = path => (
  initialContent || (typeof window !== 'undefined' ? window.__PRERENDER_CONTENT__ : undefined)
)?.[path];
export const fetchContent = async path => {
  try {
    const res = await fetch(`${API}${path}`);
    if (!res.ok) { const err = new Error(`Request failed: ${res.status}`); err.status = res.status; throw err; }
    return await res.json();
  } catch (err) {
    const cached = getInitialContent(path);
    if ((!err.status || err.status >= 500) && cached !== undefined) return cached;
    throw err;
  }
};
export { API };
